import Card from 'components/Layout/Card';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  fetchAddOnServicesData,
  fetchSubmittedAbstractsDetails,
  setPaperData,
} from 'store/slices';
import { icons } from 'utils/constants';
import UserAbstractState from './UserAbstractState';
import UserPlagiarismState from './UserPlagiarismState';
import UserReviewState from './UserReviewState';
import UserAcceptanceState from './UserAcceptanceState';
import UserRegistrationState from './UserRegistrationState';
import UserAttendanceState from './UserAttendanceState';
import './NewViewPaper.scss';
import UserAddOnServicesModal from './UserAddOnServicesModal';
import TabLayout from 'components/Layout/TabLayout';
import FullPaper from '../ResourceSide/NewPaperDetails/FullPaper';
import BasicInfo from '../ResourceSide/NewPaperDetails/BasicInfo';
import Loader from 'components/Layout/Loader';
import UserAddOnServices from './UserAddOnServices';

const tabs = [
  { key: 'abstract', label: 'Abstract' },
  { key: 'full_paper', label: 'Full Paper' },
  { key: 'add_on_services', label: 'Add-On Services' },
];

const NewViewPaper = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const revisionFormRef = useRef();
  const abstractRevisionFormRef = useRef(null);
  const { paperType, paperId, eventId } = params;
  const [isAddRevisionAbstract, setIsAddRevisionAbstract] = useState(false);

  const reduxData = useSelector((state) => state.global);
  const { paperData } = reduxData || {};
  // const [paperData, setPaperData] = useState({});

  // const reduxData = useSelector((state) => state.student);
  // const { isAddOnServices } = reduxData || {};
  const [childTabType, setChildTabType] = useState('abstract');
  const [isAddOnServicesActive, setIsAddOnServicesActive] = useState(false);
  const [scores, setScores] = useState([
    { id: 'originality', label: 'Originality', score: 0 },
    {
      id: 'contribution_to_the_field',
      label: 'Contribution to the Field',
      score: 0,
    },
    { id: 'technical_quality', label: 'Technical Quality', score: 0 },
    {
      id: 'clarity_of_presentation',
      label: 'Clarity of Presentation',
      score: 0,
    },
    { id: 'depth_of_research', label: 'Depth of Research', score: 0 },
  ]);
  const [data, setData] = useState({
    paperTitleName: '',
    paperAbstractDetail: '',
    status: '1',
    paper: '',
    paperDate: '',
    plagiarismDate: '',
    plagiarismStatus: '',
    plagiarismComment: '',
    plagiarismDocument: '',
    plagiarismExpired: '',
    revisionStatus: '',
    plagiarismAcceptedDate: '',
    isRepublish: '',
    republishDate: '',
    reviewDate: '',
    reviewComment: '',
    acceptanceDate: '',
    acceptanceStatus: '',
    registrationDate: '',
    acceptanceLetter: '',
    is_remodify: '',
    reviewing_file: '',
    is_registered_status: '0',
  });

  const getAbstractDetails = async () => {
    const response = await dispatch(fetchSubmittedAbstractsDetails(paperId));
    const {
      abstract_path,
      abstract_reviews,
      paperTitle,
      paper_abstract,
      revision_details,
      revision_details_stage_1,
      stage_1_add_abstract_btn,
      submittedPapersStatus,
      is_event_registered,
      revision_reasons,
    } = response?.data || {};
    dispatch(setPaperData(response?.data || {}));
    handelData(
      abstract_path,
      abstract_reviews,
      paperTitle,
      paper_abstract,
      revision_details,
      revision_details_stage_1,
      stage_1_add_abstract_btn,
      submittedPapersStatus,
      is_event_registered,
      revision_reasons
    );
    setLoading(false)
  };

  const handelData = (
    file,
    abstractReviews,
    paperTitle,
    paper_abstract,
    revision_details,
    revision_details_stage_1,
    stage_1_add_abstract_btn,
    paperStatusData,
    is_event_registered = '',
    revision_reasons
  ) => {
    const {
      paper_submitted_date,
      paper_submitted_status,
      plagiarism_comment,
      plagiarism_date,
      plagiarism_status,
      plagiarism_document,
      plagiarism_expired,
      plagiarism_accepted_date,
      revision_status,
      is_republish_by_admin,
      republish_date,
      review_date,
      review_comment,
      acceptance_date,
      acceptance_status,
      registration_date,
      registration_acceptance_letter,
      is_remodify,
      reviewing_file,
      is_registered_status,
    } = paperStatusData || {};
    setData({
      paper: file,
      reviewData: abstractReviews,
      paperTitleName: paperTitle,
      paperAbstractDetail: paper_abstract,
      status: +paper_submitted_status || 1,
      paperDate: paper_submitted_date,
      revisionDetails: revision_details,
      isRepublish: is_republish_by_admin,
      republishDate: republish_date,
      plagiarismDate: plagiarism_date,
      plagiarismStatus: plagiarism_status,
      plagiarismComment: plagiarism_comment,
      plagiarismDocument: plagiarism_document,
      plagiarismExpired: plagiarism_expired,
      plagiarismAcceptedDate: plagiarism_accepted_date,
      revisionStatus: revision_status,
      reviewDate: review_date,
      reviewComment: review_comment,
      acceptanceDate: acceptance_date,
      acceptanceStatus: acceptance_status,
      registrationDate: registration_date,
      acceptanceLetter: registration_acceptance_letter,
      is_remodify: is_remodify,
      reviewing_file: reviewing_file,
      is_event_registered: is_event_registered,
      is_registered_status: is_registered_status,
      revisionReasons: revision_reasons,
      revisionDetailsStage1: revision_details_stage_1,
      stage1AddAbstractBtn: stage_1_add_abstract_btn
    });
  };

  useEffect(() => {
    if (paperType === 'paper') {
      //   getPaperDetails();
    } else if (paperType === 'abstract') {
      getAbstractDetails();
    } else {
      // nothing
    }
    return () => {
      dispatch(setPaperData({}));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (paperData?.abstract_reviews) {
      const updatedScores = scores?.map((s) => {
        if (Object.keys(paperData?.abstract_reviews)?.includes(s.id)) {
          return {
            ...s,
            score: paperData?.abstract_reviews[s?.id],
          };
        }
        return s;
      });

      setScores(updatedScores);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paperData?.abstract_reviews]);

  const scrollToAbstract = (refData) => {
    if (refData?.current) {
      refData?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  const [addOnServicesData, setAddOnServicesData] = useState({});
  const fetchAddOnServices = async () => {
    const response = await dispatch(
      fetchAddOnServicesData({ event_id: eventId })
    );
    if (response?.status === 200) {
      setAddOnServicesData(response?.data || []);
    }
  };

  useEffect(() => {
    fetchAddOnServices();
  }, [eventId]);

  const { submittedPapersStatus } = paperData || {};
  const { revision_status, is_plagiarism_done, process_to_next } =
    submittedPapersStatus || {};
  const { status, plagiarismStatus, is_remodify, plagiarism_comment } =
    data || {};
  const {
    paper_submission_service,
    plag_revision_service,
    reviewer_revision_service,
  } = addOnServicesData || {};

  useEffect(() => {
    if (
      status === 1 &&
      process_to_next === '1' &&
      paper_submission_service === '1'
    ) {
      setIsAddOnServicesActive(true);
    } else if (
      ((['2'].includes(plagiarismStatus) &&
        is_plagiarism_done === '0' &&
        (process_to_next === '1' || revision_status === '2')) ||
        plagiarismStatus === '3') &&
      plag_revision_service === '1'
    ) {
      setIsAddOnServicesActive(true);
    } else if (
      is_plagiarism_done === '0' &&
      revision_status === '2' &&
      status === 3 &&
      is_remodify === '1' &&
      reviewer_revision_service === '1'
    ) {
      setIsAddOnServicesActive(true);
    } else if (is_remodify === '3' && reviewer_revision_service === '1') {
      setIsAddOnServicesActive(true);
    } else if (
      plagiarismStatus === '3' &&
      plagiarism_comment &&
      plag_revision_service === '1'
    ) {
      setIsAddOnServicesActive(true);
    } else {
      setIsAddOnServicesActive(false);
    }
  }, [data, submittedPapersStatus, addOnServicesData]);

  const [isPaperDetail, setIsPaperDetail] = useState(true);
  const [isLoading, setLoading] = useState(true);


  return (

    <div className='new-view-paper-container'>
      {isLoading ? <Card className="cps-44 cpt-25 cpe-44 cpb-25">
        <div className="pt-5 pb-5">
          <Loader size="md" />
        </div>
      </Card> :
        <>
          {!isLoading && (
            <Card className="cmb-18">
              <div className="bg-f4ff color-new-car text-14-500-17 cps-44 cpt-12 cpe-28 cpb-12 d-flex align-items-center gap-2">
                <div
                  className="d-flex"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <img
                    src={icons.leftArrow}
                    alt="back"
                    className="h-21 me-3 pointer"
                  />
                </div>
                <div
                  className="d-flex align-items-center justify-content-between pointer flex-grow-1"
                  onClick={() => {
                    setIsPaperDetail(!isPaperDetail);
                  }}
                >
                  <div>{paperData?.paperId}</div>
                  <i
                    className={`${isPaperDetail ? 'bi bi-chevron-up' : 'bi bi-chevron-down'
                      }`}
                    style={{ fontSize: '15px' }}
                  />
                </div>
              </div>

              {isPaperDetail && (
                <BasicInfo
                  paperData={paperData}
                />
              )}
            </Card>
          )}

          {!isLoading && (
            <Card className="cps-20 cpe-20  cpt-8 cpb-8 mb-2">
              <TabLayout
                tabs={tabs}
                activeKey={childTabType}
                onChange={setChildTabType}
                variant="background"
              />
            </Card>)}

          {childTabType === 'abstract' ? (
            <Card className="cpt-40 cpb-40 cps-40 cpe-40">


              {/* Abstract */}
              <UserAbstractState
                ref={abstractRevisionFormRef}
                data={data}
                paperData={paperData}
                handleSuccess={() => {
                  getAbstractDetails();
                }}
                isAddRevisionAbstract={isAddRevisionAbstract}
                setIsAddRevisionAbstract={setIsAddRevisionAbstract}
                revisionFormRef={revisionFormRef}
              />

              {/* Plagiarism */}
              <UserPlagiarismState
                data={data}
                setIsAddRevisionAbstract={setIsAddRevisionAbstract}
                paperData={paperData}
                scrollToAbstract={scrollToAbstract}
                revisionFormRef={revisionFormRef}
              />

              {/* Review */}
              <UserReviewState
                data={data}
                paperData={paperData}
                handleSuccess={() => {
                  getAbstractDetails();
                }}
                setIsAddRevisionAbstract={setIsAddRevisionAbstract}
                revisionFormRef={revisionFormRef}
                scrollToAbstract={scrollToAbstract}
              />

              {/* Acceptance */}
              <UserAcceptanceState data={data} paperData={paperData} />

              {/* Registration */}
              <UserRegistrationState
                data={data}
                paperData={paperData}
                handleSuccess={() => {
                  getAbstractDetails();
                }}
              />

              {/* Attendance */}
              <UserAttendanceState
                data={data}
                paperData={paperData}
                handleSuccess={() => {
                  getAbstractDetails();
                }}
              />
            </Card>
          ) : childTabType === 'full_paper' ? (
            <FullPaper />
          ) : childTabType === 'add_on_services' ? <UserAddOnServices /> : <>Page Not Found</>}

          {isAddOnServicesActive && (
            <UserAddOnServicesModal
              onHide={() => {
                setIsAddOnServicesActive(false);
                setAddOnServicesData({});
              }}
              addOnServicesData={addOnServicesData}
            />
          )}
        </>
      }

    </div>
  );
};

export default NewViewPaper;
{/* <Card className="d-flex align-items-center cps-12 cpt-12 cpb-12 unset-br mb-3">
        <span
          className="d-flex ps-2"
          onClick={() => {
            navigate(-1);
          }}
        >
          <img src={icons.leftArrow} alt="back" className="h-21 me-3 pointer" />
          Submitted Abstract Track
        </span>
      </Card> */}